module.exports = __webpack_public_path__ + "static/media/mov-govt-logo.2d71e66f.svg";